/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { fetchDate } from "../../../utils/globleFunc";
import {
  ShoppingCart,
  Check,
  X,
  RefreshCw,
  Lock,
  Bell,
  Info,
  ArrowLeft,
  AlertTriangle,
  Activity,
  Clock,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ActivationAbandonedOrders({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [isFeatureActive, setIsFeatureActive] = useState(false);
  const [initialState, setInitialState] = useState(null);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (store) {

      setInitialState({ ...store });
      setIsFeatureActive(Boolean(store.orderabondant));
    }
  }, [store]);

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();
    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.abandonedOrders.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.abandonedOrders.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  // Check if state has changed
  const hasStateChanged = () => {
    if (!initialState) return false;
    return data.orderabondant !== initialState.orderabondant;
  };

  const handleDChange = () => {
    setData({ ...data, orderabondant: !data.orderabondant });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if state has changed
    if (!hasStateChanged()) {
      await showAlert(
        "info",
        t("servicePageActivation.abandonedOrders.alerts.noChanges.title"),
        t("servicePageActivation.abandonedOrders.alerts.noChanges.text")
      );
      return;
    }

    // Check if we're activating or deactivating
    const isActivating = data.orderabondant && !isFeatureActive;
    const isDeactivating = !data.orderabondant && isFeatureActive;

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.abandonedOrders.alerts.confirmDeactivation.title"),
        t("servicePageActivation.abandonedOrders.alerts.confirmDeactivation.text"),
        true,
        t("servicePageActivation.abandonedOrders.alerts.confirmDeactivation.confirmButton")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset toggle to previous state
        setData({ ...data, orderabondant: true });
        return;
      }
    }

    try {
      setLoading(true);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);
      setInitialState({ ...data });
      setIsFeatureActive(data.orderabondant);

      if (isDeactivating) {
        await showAlert(
          "success",
          t("servicePageActivation.abandonedOrders.alerts.success.deactivated.title"),
          ""
        );
      } else if (isActivating) {
        await showAlert(
          "success",
          t("servicePageActivation.abandonedOrders.alerts.success.activated.title"),
          ""
        );
      } else {
        await showAlert(
          "success",
          t("servicePageActivation.abandonedOrders.alerts.success.saved.title"),
          ""
        );
      }
      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.abandonedOrders.alerts.error.deactivation.title"),
          t("servicePageActivation.abandonedOrders.alerts.error.deactivation.text")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.abandonedOrders.alerts.error.saving.title"),
          t("servicePageActivation.abandonedOrders.alerts.error.deactivation.text")
        );
      }

      console.error("Error saving Abandoned Orders settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.abandonedOrders.alerts.paidFeature.title"),
      t("servicePageActivation.abandonedOrders.alerts.paidFeature.text"),
      true,
      t("servicePageActivation.abandonedOrders.alerts.paidFeature.confirmButton")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };
  //moumen what this ???
  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3">
              {t("servicePageActivation.abandonedOrders.locked.title")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
              {t("servicePageActivation.abandonedOrders.locked.description")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.abandonedOrders.locked.cta")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <ShoppingCart className="ml-2" size={20} />
            {t("servicePageActivation.abandonedOrders.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.abandonedOrders.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg ${
            isFeatureActive
              ? "bg-green-50 border border-green-200 dark:!bg-green-900 dark:!border-green-700"
              : "bg-gray-50 border border-gray-200 dark:!bg-[#1e1e1e] dark:!border-[#3c3a3d]"
          }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${
                isFeatureActive
                  ? "bg-green-500"
                  : "bg-gray-400 dark:!bg-gray-500"
              }`}
            ></div>
            <span
              className={`text-sm font-medium ${
                isFeatureActive
                  ? "text-green-700 dark:!text-green-300"
                  : "text-gray-700 dark:!text-gray-400"
              }`}
            >
              {isFeatureActive
                ? t("servicePageActivation.abandonedOrders.status.active")
                : t("servicePageActivation.abandonedOrders.status.inactive")}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium text-[#9e68ba]">
                {t("servicePageActivation.abandonedOrders.toggle.label")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium ${
                  data.orderabondant
                    ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                    : "bg-gray-100 text-gray-800 dark:!bg-[#2b2b2b] dark:!text-gray-400"
                }`}
              >
                {data.orderabondant
                  ? t("servicePageActivation.abandonedOrders.toggle.active")
                  : t("servicePageActivation.abandonedOrders.toggle.inactive")}
              </div>
            </div>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.orderabondant
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#2a1f33] dark:!border-purple-800"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#1e1e1e] dark:!border-[#3c3a3d] dark:hover:!bg-[#2a2a2a]"
              }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.orderabondant}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.orderabondant ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                      data.orderabondant
                        ? "rtl:-translate-x-6 ltr:translate-x-6"
                        : "translate-x-0"
                    }`}
                  />
                </label>
              </div>
              <div>
                <div className="flex items-center">
                  {data.orderabondant ? (
                    <ShoppingCart size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <X size={18} className="ml-2 text-gray-500" />
                  )}
                  <p className="font-medium">
                    {data.orderabondant
                      ? t(
                          "servicePageActivation.abandonedOrders.toggle.enabledTitle"
                        )
                      : t(
                          "servicePageActivation.abandonedOrders.toggle.disabledTitle"
                        )}
                  </p>
                </div>
                <p className="text-sm text-gray-500 dark:!text-gray-400 mt-1">
                  {data.orderabondant
                    ? t(
                        "servicePageActivation.abandonedOrders.toggle.enabledDescription"
                      )
                    : t(
                        "servicePageActivation.abandonedOrders.toggle.disabledDescription"
                      )}
                </p>
              </div>
            </div>
          </div>

          {/* Feature Benefits */}
          {data.orderabondant && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Conversion Benefit */}
              <div className="rounded-lg p-4 border border-gray-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <div className="flex items-center text-gray-800 dark:!text-gray-200 mb-2">
                  <ArrowLeft size={18} className="ml-2 text-purple-500" />
                  <h4 className="font-medium">
                    {t(
                      "servicePageActivation.abandonedOrders.benefits.conversion.title"
                    )}
                  </h4>
                </div>
                <p className="text-sm text-gray-700 dark:!text-gray-400">
                  {t(
                    "servicePageActivation.abandonedOrders.benefits.conversion.text"
                  )}
                </p>
              </div>

              {/* Reminder Benefit */}
              <div className="rounded-lg p-4 border border-gray-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <div className="flex items-center text-gray-800 dark:!text-gray-200 mb-2">
                  <Bell size={18} className="ml-2 text-purple-500" />
                  <h4 className="font-medium">
                    {t(
                      "servicePageActivation.abandonedOrders.benefits.reminder.title"
                    )}
                  </h4>
                </div>
                <p className="text-sm text-gray-700 dark:!text-gray-400">
                  {t(
                    "servicePageActivation.abandonedOrders.benefits.reminder.text"
                  )}
                </p>
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-lg text-blue-800 dark:!text-blue-300 mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.abandonedOrders.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Check size={14} className="text-blue-600 mt-1" />
                </span>
                <span>
                  {t("servicePageActivation.abandonedOrders.tips.list.0")}
                </span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Bell size={14} className="text-blue-600 mt-1" />
                </span>
                <span>
                  {t("servicePageActivation.abandonedOrders.tips.list.1")}
                </span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Clock size={14} className="text-blue-600 mt-1" />
                </span>
                <span>
                  {t("servicePageActivation.abandonedOrders.tips.list.2")}
                </span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Activity size={14} className="text-blue-600 mt-1" />
                </span>
                <span>
                  {t("servicePageActivation.abandonedOrders.tips.list.3")}
                </span>
              </li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || !hasStateChanged()}
            className={`px-6 py-3 ${
              !hasStateChanged()
                ? "bg-gray-400"
                : !data.orderabondant && isFeatureActive
                ? "bg-red-500 hover:bg-red-600"
                : "bg-[#9b59bf] hover:bg-[#814a9f]"
            } text-white rounded-lg transition-colors flex items-center justify-center ${
              loading || !hasStateChanged()
                ? "opacity-70 cursor-not-allowed"
                : ""
            }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.orderabondant
                  ? t("servicePageActivation.abandonedOrders.button.enabling")
                  : t("servicePageActivation.abandonedOrders.button.disabling")}
              </>
            ) : (
              <>
                {!hasStateChanged() ? (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.abandonedOrders.button.noChange")}
                  </>
                ) : !data.orderabondant && isFeatureActive ? (
                  <>
                    <X className="ml-2" size={18} />
                    {t("servicePageActivation.abandonedOrders.button.disable")}
                  </>
                ) : data.orderabondant && !isFeatureActive ? (
                  <>
                    <Check className="ml-2" size={18} />
                    {t("servicePageActivation.abandonedOrders.button.enable")}
                  </>
                ) : (
                  <>
                    <Check className="ml-2" size={18} />
                    {t("servicePageActivation.abandonedOrders.button.save")}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
